import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {useFavourites} from "../../../favorite/hooks/use_favourites";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

interface Props {
    offerId: number;
}

export const ConstructionGalleryPlaceholder = (props: Props) => {
    const {offerId} = props;
    const {addOfferToFavourites, removeOfferFromFavourites, isOfferInFavourites, loaded} = useFavourites();

    const isInFavourites = isOfferInFavourites(offerId);
    const btnText = isInFavourites ? "Usuń z ulubionych" : "Dodaj do ulubionych";

    const handleClick = async () => {
        if (isInFavourites) {
            await removeOfferFromFavourites(offerId);
        } else {
            await addOfferToFavourites(offerId);
        }
    };

    return (
        <div className={holder}>
            <div className={innerStyle}>
                <Image
                    src={missingConstructionImagesSVG}
                    width="260px"
                    height="244px"
                    alt="kartka zawierająca prosty schemat bloku mieszkalnego"
                    className={imageStyle}
                />
                <Text variant="headline_3" as="p" color="white" align="center" mb={3}>
                    Zdjęcia z budowy nie są jeszcze dostępne
                </Text>
                <Text variant="body_copy_1" color="white" align="center" mb={3}>
                    {isInFavourites ? "Dodaliśmy" : "Dodaj"} tę ofertę do obserwowanych na Twoim koncie {isInFavourites ? "i" : "a"} powiadomimy Cię, gdy
                    zdjęcia się pojawią.
                </Text>
                <Button variant="outlined_secondary_light" onClick={handleClick} className={btnStyle}>
                    {loaded ? btnText : <Loader size="sm" />}
                </Button>
            </div>
        </div>
    );
};

const holder = css({
    p: 2,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    h: "80%",
    overflow: "auto",

    md: {
        justifyContent: "center",
        flexDirection: "row",
        h: "100%"
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: "460px"
});

const imageStyle = css({
    mb: 4,
    display: "flex",
    justifyContent: "center"
});

const btnStyle = css({
    maxWidth: "240px",
    mx: "auto"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {useFavourites} from "../../../favorite/hooks/use_favourites";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

interface Props {
    offerId: number;
}

export const ConstructionGalleryPlaceholder = (props: Props) => {
    const {offerId} = props;
    const {addOfferToFavourites, removeOfferFromFavourites, isOfferInFavourites, loaded} = useFavourites();

    const isInFavourites = isOfferInFavourites(offerId);
    const btnText = isInFavourites ? "Usuń z ulubionych" : "Dodaj do ulubionych";

    const handleClick = async () => {
        if (isInFavourites) {
            await removeOfferFromFavourites(offerId);
        } else {
            await addOfferToFavourites(offerId);
        }
    };

    return (
        <div className={holder}>
            <div className={innerStyle}>
                <Image
                    src={missingConstructionImagesSVG}
                    width="260px"
                    height="244px"
                    alt="kartka zawierająca prosty schemat bloku mieszkalnego"
                    className={imageStyle}
                />
                <Text variant="headline_3" as="p" color="white" align="center" mb={3}>
                    Zdjęcia z budowy nie są jeszcze dostępne
                </Text>
                <Text variant="body_copy_1" color="white" align="center" mb={3}>
                    {isInFavourites ? "Dodaliśmy" : "Dodaj"} tę ofertę do obserwowanych na Twoim koncie {isInFavourites ? "i" : "a"} powiadomimy Cię, gdy
                    zdjęcia się pojawią.
                </Text>
                <Button variant="outlined_secondary_light" onClick={handleClick} className={btnStyle}>
                    {loaded ? btnText : <Loader size="sm" />}
                </Button>
            </div>
        </div>
    );
};

const holder = css({
    p: 2,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    h: "80%",
    overflow: "auto",

    md: {
        justifyContent: "center",
        flexDirection: "row",
        h: "100%"
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: "460px"
});

const imageStyle = css({
    mb: 4,
    display: "flex",
    justifyContent: "center"
});

const btnStyle = css({
    maxWidth: "240px",
    mx: "auto"
});
